<script>
    import {onMount } from 'svelte';
    import {Info, CirclePlus, Minus} from 'lucide-svelte';

    import UpgradeFeature from './UpgradeFeature.svelte';

    export let visible = false;
    export let onClose = () => {};
    export let premiumGifs =[];

    let billingCycle = 'monthly';

    let defaultCurrency = 'GBP'; // Initial default
    let selectedCurrency;  

    const stripeLinks = {
        monthly: {
            GBP: 'https://buy.stripe.com/fZedTL2LEenx0a4fZ1',
            USD: 'https://buy.stripe.com/9B6cN44ZrgDGes24xx8so07',
            EUR: 'https://buy.stripe.com/fZubJ08bD5Z2gAa8NN8so06'
        },
        yearly: {
            GBP: 'https://buy.stripe.com/dRm28qeA1dru5Vw4xx8so09',
            USD: 'https://buy.stripe.com/bJeeVcajL3QUgAa2pp8so04',
            EUR: 'https://buy.stripe.com/00w7sK0JbdruabM3tt8so05'
        }
    };
    $: stripeLink = stripeLinks[billingCycle]?.[selectedCurrency] || 'your_default_link';

    const prices = {
        monthly: {
            GBP: '£24 per month',
            USD: '$30 per month',
            EUR: '€26 per month'
        },
        yearly: {
            GBP: '£260 per year',
            USD: '$346 per year',
            EUR: '€308 per year'
        }
    };
    $: currentPrice = prices[billingCycle]?.[selectedCurrency] || 'Price not available';
    
    $: currentCurrency = ( () => {
        switch (selectedCurrency) {
          case 'EUR':
          return '€';
          case 'USD':
          return '$';
          default:
            return '£';
     }
    })();

    onMount(async () => {
        determineDefaultCurrencyByLocale();
        selectedCurrency = defaultCurrency;
    })

    function determineDefaultCurrencyByLocale() {
        const browserLocale = navigator.language || navigator.userLanguage;
        console.log('Browser Locale:', browserLocale);

        if (browserLocale) {
        const countryCode = browserLocale.split('-')[1]?.toUpperCase();

        if (countryCode === 'US') {
            defaultCurrency = 'USD';
        } else if (['DE', 'FR', 'ES', 'IT', 'BE', 'AT', 'IE', 'LU', 'NL', 'PT', 'FI', 'GR', 'SI', 'CY', 'MT', 'SK', 'EE', 'LV', 'LT'].includes(countryCode)) {
            defaultCurrency = 'EUR';
        } else {
            defaultCurrency = 'GBP'; // Explicitly set default if no match
        }
        } else {
        console.warn('Could not determine browser locale, defaulting to GBP.');
        }
     }

    function handleUpgradeClick(event) {
      event.preventDefault();

      if (typeof gtag !== 'undefined') {
        gtag('event', 'upgrade_select_plan', {
          plan_id: 'team_success',
          billing_cycle: billingCycle,
          billing_currency: selectedCurrency
        });
      }

      // Navigate to Stripe after slight delay (to ensure event fires)
      setTimeout(() => {
        window.location.href = stripeLink;
      }, 200);
    }
  </script>
  
  {#if visible}
    <div class="modal modal-open z-50">
      <!-- Click trap -->
        <div
          class="absolute inset-0 bg-black bg-opacity-50"
          on:click={onClose}
        ></div>

      <div class="modal-box max-w-5xl" on:click|stopPropagation>

        <div class="flex flex-row align-center">
          <img src="/images/Logo_webclip_256.png" alt="MoodFirst Logo" style="width: 40px; height: auto;">
          <h3 class="font-bold text-2xl text-[var(--blue)] ml-2">
            Our Plans
          </h3>

          <div id="schedule-currency-layout" class="flex flex-row ml-auto self-center">

            <!-- Pay Monthly or Yearly -->
            <div id="pay-monthly-yearly" class="">
                <div class="join">
                <input
                    type="radio"
                    name="billing"
                    value="monthly"
                    bind:group={billingCycle}
                    aria-label="Monthly Payments"
                    class="join-item btn btn-xs focus:outline-none"
                    class:bg-[#808080]={billingCycle === 'monthly'}
                    class:text-white={billingCycle === 'monthly'}
                />
            
                <input
                    type="radio"
                    name="billing"
                    value="yearly"
                    bind:group={billingCycle}
                    aria-label="Annual Payments"
                    class="join-item btn btn-xs focus:outline-none"
                    class:bg-[#808080]={billingCycle === 'yearly'}
                    class:text-white={billingCycle === 'yearly'}
                />
                </div>

            </div>

            <!--  Select Currency -->
            <div id="select-currency" class="flex row ml-4">
                    <div class="form-control w-full max-w-xs flex flex-row">
                    <label for="currency" class="label flex items-center">
                        <span class="label-text text-sm">Price in:&nbsp;</span>
                    </label>
                    <select id="currency" class="select select-bordered select-xs font-bold text-[#808080]" bind:value={selectedCurrency}>
                        <option value="GBP">GBP (United Kingdom)</option>
                        <option value="USD">USD (United States)</option>
                        <option value="EUR">EUR (European Union)</option>
                    </select>
                    </div>         
            </div>

    </div>  
        </div>

        <div id="title-layout" class="flex flex-row align-center">
        
        <div class="text-base text-gray-600 mb-2 mt-6 font-bold">
           <span class="text-3xl">🚀</span> Select the plan that's right for you.
        </div>

        

        </div>


        <div class="border border-gray-300 rounded overflow-hidden">
        
            <div class="grid divide-y divide-gray-300">

                   <!-- Row 0 -->
               <!-- <div class="grid grid-cols-3 divide-x divide-gray-300 h-4">
                    <div class="h4 bg-[#d6d6d6]"></div>
                    <div class="h4 bg-[#FF6B6B]"></div>
                    <div class="h4 bg-[#F7DC6F]"></div>               
                </div> -->


              <!-- Row 1 -->
              <div class="grid grid-cols-3 divide-x divide-gray-300">
                <div class="py-1.5 px-4 text-center text-xl font-bold text-[var(--blue)]">
                    Free Edition
                </div>
                <div class="py-1.5 px-4 text-center">
                    <div class="text-xl font-bold text-[var(--blue)]">Team Success Edition</div>
                    <!-- <div class="bg-[var(--green)] px-1 rounded-sm">Recommended</div> -->
                     <span class="inline-block bg-[var(--green)] px-1 rounded-sm">
            Recommended
    </span>
                </div>
                <div class="py-1.5 px-4 text-center text-xl font-bold text-[var(--blue)]">
                    Enterprise Edition
                </div>
              </div>
              
              <!-- Row 2 -->
                <div class="grid grid-cols-3 divide-x divide-gray-300">
                    <div class="p-2 text-center flex items-center justify-top flex-column">
                      <div class="text-xl font-bold text-[var(--aqua)]">
                        {currentCurrency}0
                      </div>
                      <div class="text-sm text-[var(--aqua)]"> &nbsp;</div>
                      <div class="text-sm">
                        For smaller teams who want to work better together </div>
                    </div>
                    <div class="p-2 text-center flex items-center justify-top transition-all duration-300 ease-in-out flex-column">
                        <div  class="text-xl font-bold text-[var(--aqua)] animate-[fadeInPop_0.3s_ease-out]" key={`${billingCycle}-${selectedCurrency}`}>{currentPrice}</div>
                         <div class="text-sm text-[var(--aqua)]">Flat price per workspace.</div>
                        <div class="text-sm">
                          For growing teams who want to create <i>stronger connections</i> and support <i>better collaboration</i>.
                        </div>
                    </div>
                    <div class="p-2 text-cente flex items-center justify-top flex-column">
                      <div class="text-xl font-bold text-[var(--aqua)]">Contact Us</div>
                       <div class="text-sm text-[var(--aqua)]"> &nbsp;</div>
                      <div class="text-sm">
                       Drive cultural change across all your teams by rolling out MoodFirst across your orgnisation.
                      </div>
                    </div>
                </div>
  

      
              
               <!-- Row 3 -->
              <div class="grid grid-cols-3 divide-x divide-gray-300">
                <div class="p-2">
                  <UpgradeFeature title="2 Free Team Mood Boards" icon="🌟">
                    Get started for free with 2 team mood boards.
                  </UpgradeFeature>
                </div>
                <div class="p-2">
                    <div class="font-bold mb-2 text-[var(--blue)]">Everything in the free edition +</div>
                    
                    <UpgradeFeature title="Extra Emoji & Stickers" icon="🎁" highlight>
                      Be even more expressive with extra <i>mood categories</i>, <em>stickers</em> and <em> suggested emoj!</em>
                      <div class="flex flex-row mt-1 min-h-[32px]">
                            {#each premiumGifs.slice(0,4) as premiumGif}
                              <img alt="Mood description" class="w-8 h-auto mr-2 mood-text-gif mood-description-gif-img" src={premiumGif.GifURL} title="">
                            {/each} 
                      </div>
                     </UpgradeFeature>

                  <UpgradeFeature title="Microsoft Teams Reminders" icon="⏰" highlight>
                    Never miss a mood check with automated messages to your Microsft Teams Channel.
                  </UpgradeFeature>

                  <UpgradeFeature title="Create up to 10 Team Mood Boards" icon="🧑‍🤝‍🧑">
                    Create board for up to <b>10</b> teams.
                  </UpgradeFeature>

                  <UpgradeFeature title="Agile Meeting Templates" icon="📋">
                    Customised mood board questions for agile ceremonies.
                  </UpgradeFeature>
                      
                </div>
                <div class="p-2">
                    <div class="font-bold mb-2 text-[var(--blue)]">Everything in the Success edition +</div>
                        <UpgradeFeature title="Unlimited Team Mood Boards" icon="✨">
                            Transform your organisation by rolling out out team mood check-ins across the enterprise.
                        </UpgradeFeature>
                        <UpgradeFeature title="Team 2 Team Messaging" icon="🔗">
                          Break down organisational barriers by helping teams to build connections and boost collaboration.                        
                        </UpgradeFeature>
                        <UpgradeFeature title="Invite-Only Boards" icon="🔒">
                            Create boards that only authorised users can join.
                        </UpgradeFeature>
                        <UpgradeFeature title="Single Sign-On" icon="🔑">
                            Simplify logging in by using secure SAML single sign-on.
                        </UpgradeFeature>
                        <UpgradeFeature title="Automated User Provisioning" icon="⚙️">
                            Automatically provision users using the SCIM protocol.
                        </UpgradeFeature>
                </div>
              </div>


            <!-- Row 4 -->
              <div class="grid grid-cols-3 divide-x Xdivide-gray-300">
                <div class="p-2 text-center text-[#808080] font-semibold text-base flex items-center justify-center">
                    Current Plan
                </div>
                <div class="p-4 text-center" on:click={() => logUpgradeEvent('upgrade_select_plan')}>
                    <!-- <a href={stripeLink}> -->
                        <button class="btn btn-lg mt-2 bg-[var(--aqua)] text-white border-none hover:opacity-90 w-[210px]"  on:click={handleUpgradeClick}>
                        Let's Go
                        </button>
                      <!-- </a> -->
                </div>
                <div class="p-4 text-center">
                    <a href="mailto:info@moodfirst.ai">
                        <button class="btn btn-lg mt-2 bg-[#808080] text-white border-none hover:opacity-90 w-[210px]">
                            Contact Us
                            </button>
                   </a>
                </div>
              </div>

            </div>
          </div>

          <!-- <div>
              If you can't find a plan that works for you or you need more options just <a href="mailto:info@moodfirst.ai">email us</a>.
          </div> -->

        <div class="modal-action mt-6">
          <button class="btn bg-[#808080] text-white" on:click={onClose}>Close</button>
        </div>
      </div>
    </div>
  {/if}
  
<style>
    @keyframes fadeInPop {
      0% {
        opacity: 0;
        transform: scale(0.95);
      }
      100% {
        opacity: 1;
        transform: scale(1);
      }
    }
  
    .animate-\[fadeInPop_0\.3s_ease-out\] {
      animation: fadeInPop 0.4s ease-out;
    }
  </style>
  